// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Zone_Type from "../zone/Zone_Type.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Util_Array from "../util/Util_Array.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Presse_Page from "../presse/Presse_Page.bs.js";
import * as Type_String from "./Type_String.bs.js";
import * as Type_Category from "./Type_Category.bs.js";

var Description_t_encode = Type_String.$$String.t_encode;

var Description_t_decode = Type_String.$$String.t_decode;

var Description_toString = Type_String.$$String.toString;

var Description_empty = Type_String.$$String.empty;

var Description_make = Type_String.$$String.make;

var Description_makeFromNullable = Type_String.$$String.makeFromNullable;

var Description_makeFromNullableOrEmpty = Type_String.$$String.makeFromNullableOrEmpty;

var Description = {
  t_encode: Description_t_encode,
  t_decode: Description_t_decode,
  toString: Description_toString,
  empty: Description_empty,
  make: Description_make,
  makeFromNullable: Description_makeFromNullable,
  makeFromNullableOrEmpty: Description_makeFromNullableOrEmpty
};

var Title_t_encode = Type_String.$$String.t_encode;

var Title_t_decode = Type_String.$$String.t_decode;

var Title_toString = Type_String.$$String.toString;

var Title_empty = Type_String.$$String.empty;

var Title_make = Type_String.$$String.make;

var Title_makeFromNullable = Type_String.$$String.makeFromNullable;

var Title_makeFromNullableOrEmpty = Type_String.$$String.makeFromNullableOrEmpty;

var Title = {
  t_encode: Title_t_encode,
  t_decode: Title_t_decode,
  toString: Title_toString,
  empty: Title_empty,
  make: Title_make,
  makeFromNullable: Title_makeFromNullable,
  makeFromNullableOrEmpty: Title_makeFromNullableOrEmpty
};

function emacParentToParent(parent) {
  if (!(parent == null)) {
    return {
            label: parent.label,
            url: parent.url,
            page: Caml_option.nullable_to_opt(parent.page),
            parent: emacParentToParent(parent.parent)
          };
  }
  
}

function fromEmacPage(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, pageKind, page) {
  var parent = emacParentToParent(page.parent);
  var category = Type_Category.encode(page.page);
  return {
          page: category,
          description: page.description,
          url: page.url,
          parent: parent,
          title: page.title,
          zones: Zone_Type.transformZones(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, category, parent, page.description, page.url, pageKind, page.zones)
        };
}

function fromEmacV4(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, pageKind, timeReference, page) {
  var parent = emacParentToParent(page.parent);
  var category = Type_Category.encode(page.code);
  var description = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(page.metadata.description), "");
  return {
          page: category,
          description: description,
          url: page.url,
          parent: parent,
          title: Belt_Option.getWithDefault(Caml_option.nullable_to_opt(page.metadata.title), ""),
          zones: Zone_Type.transformZonesV4(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, category, parent, description, page.url, pageKind, page.zones)
        };
}

function makeNextDiffusionLabel(labels, availability, nextBroadcast) {
  var labelByAvailability;
  if (availability !== undefined) {
    var match = availability.type_;
    labelByAvailability = match === "LIVESTREAM_TV" ? labels.program.next_broadcast : labels.program.live_on;
  } else {
    labelByAvailability = labels.program.next_broadcast;
  }
  if (nextBroadcast !== undefined && nextBroadcast.length !== 0) {
    return labels.program.next_broadcast;
  } else {
    return labelByAvailability;
  }
}

function getLabelFromMeta(labels, meta, nextBroadcast) {
  switch (meta.TAG | 0) {
    case /* AudioVersions */0 :
        return labels.program.accessible;
    case /* Available */1 :
        return labels.program.available;
    case /* Duration */2 :
        return labels.program.duration;
    case /* Genre */3 :
        return labels.program.genre;
    case /* NextDiffusion */4 :
        return makeNextDiffusionLabel(labels, meta._1, nextBroadcast);
    case /* AllDiffusions */5 :
        return labels.program.next_broadcast;
    
  }
}

function getValue(meta) {
  switch (meta.TAG | 0) {
    case /* AudioVersions */0 :
        return {
                TAG: /* AudioVersions */1,
                _0: meta._0
              };
    case /* Available */1 :
        return {
                TAG: /* String */0,
                _0: meta._0
              };
    case /* Duration */2 :
        return {
                TAG: /* String */0,
                _0: Curry._1(Type_String.Teaser.DurationLabel.toString, meta._0)
              };
    case /* Genre */3 :
        return {
                TAG: /* Genre */2,
                _0: meta._0
              };
    case /* NextDiffusion */4 :
        return {
                TAG: /* String */0,
                _0: Curry._1(Type_String.Teaser.BroadcastDate.toString, meta._0)
              };
    case /* AllDiffusions */5 :
        return {
                TAG: /* MultiString */3,
                _0: Belt_Array.map(meta._0, Type_String.Teaser.BroadcastDate.toString)
              };
    
  }
}

function metaToMetaItem(labels, meta, nextBroadcast) {
  return {
          label: getLabelFromMeta(labels, meta, nextBroadcast),
          value: getValue(meta)
        };
}

function nextDiffusion(nextBroadcast, availability) {
  return Belt_Option.map(Belt_Option.flatMap(nextBroadcast, Util_Array.getFirstElement), (function (value) {
                return {
                        TAG: /* NextDiffusion */4,
                        _0: value,
                        _1: availability
                      };
              }));
}

function audioVersions(__x) {
  return Belt_Option.map(__x, (function (value) {
                return {
                        TAG: /* AudioVersions */0,
                        _0: value
                      };
              }));
}

function duration(__x) {
  return Belt_Option.map(__x, (function (value) {
                return {
                        TAG: /* Duration */2,
                        _0: value
                      };
              }));
}

function genre(__x) {
  return Belt_Option.map(__x, (function (value) {
                return {
                        TAG: /* Genre */3,
                        _0: value
                      };
              }));
}

function available(availability) {
  return Belt_Option.map(Belt_Option.flatMap(availability, (function (param) {
                    return param.label;
                  })), (function (value) {
                return {
                        TAG: /* Available */1,
                        _0: value
                      };
              }));
}

function allDiffusions(broadcasts) {
  return Belt_Option.map(broadcasts, (function (value) {
                return {
                        TAG: /* AllDiffusions */5,
                        _0: value
                      };
              }));
}

function makeMetas(pageFromOpt, labels, programContent) {
  var pageFrom = pageFromOpt !== undefined ? pageFromOpt : /* Emac */0;
  return Belt_Option.map(programContent, (function (program) {
                var teaser = program.VAL[0];
                var tmp;
                if (pageFrom) {
                  tmp = Belt_Option.map(teaser.broadcastDates, (function (value) {
                          return {
                                  TAG: /* AllDiffusions */5,
                                  _0: value
                                };
                        }));
                } else {
                  var availability = teaser.availability;
                  tmp = Belt_Option.map(Belt_Option.flatMap(teaser.broadcastDates, Util_Array.getFirstElement), (function (value) {
                          return {
                                  TAG: /* NextDiffusion */4,
                                  _0: value,
                                  _1: availability
                                };
                        }));
                }
                return Belt_Array.map(Util_Array.catOption([
                                Belt_Option.map(teaser.durationLabel, (function (value) {
                                        return {
                                                TAG: /* Duration */2,
                                                _0: value
                                              };
                                      })),
                                available(teaser.availability),
                                Belt_Option.map(teaser.program.genre, (function (value) {
                                        return {
                                                TAG: /* Genre */3,
                                                _0: value
                                              };
                                      })),
                                tmp,
                                Belt_Option.map(teaser.audioVersions, (function (value) {
                                        return {
                                                TAG: /* AudioVersions */0,
                                                _0: value
                                              };
                                      }))
                              ]), (function (__x) {
                              return metaToMetaItem(labels, __x, teaser.broadcastDates);
                            }));
              }));
}

function makeSliderDownload(pictures) {
  return {
          title: pictures.title,
          id: pictures.id,
          items: Presse_Page.filesToDownloadElements(pictures.files),
          href: pictures.zip
        };
}

function makeSliderVideo(videos, toDsTeaser) {
  return {
          title: videos.title,
          id: videos.id,
          items: Belt_Array.map(videos.teasers, Curry.__1(toDsTeaser))
        };
}

function makeFromPresse(labels, pressePage, dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, page) {
  var makeProgramContent = function (program) {
    return {
            NAME: "ProgramContent",
            VAL: [
              Presse_Page.toDsTeaser(program, dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, labels.common.firstBroadcast, page),
              undefined,
              /* Auto */0
            ]
          };
  };
  var toDsTeaser = function (param) {
    return Presse_Page.toDsTeaser(param, dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, "", page);
  };
  var programContent = makeProgramContent(pressePage.zones.program);
  var programMetas = makeMetas(/* Presse */1, labels, programContent);
  return {
          download: Belt_Option.map(pressePage.zones.pictures, makeSliderDownload),
          videos: Belt_Option.map(Caml_option.nullable_to_opt(pressePage.zones.videos), (function (param) {
                  return makeSliderVideo(param, toDsTeaser);
                })),
          programContent: programContent,
          meta: programMetas,
          ctas: Presse_Page.programToCtas(pressePage.zones.program, labels.common.firstBroadcast),
          backlink: Caml_option.nullable_to_opt(pressePage.zones.backlink)
        };
}

var Presse = {
  makeSliderDownload: makeSliderDownload,
  makeSliderVideo: makeSliderVideo,
  makeFromPresse: makeFromPresse
};

export {
  Description ,
  Title ,
  emacParentToParent ,
  fromEmacPage ,
  fromEmacV4 ,
  makeNextDiffusionLabel ,
  getLabelFromMeta ,
  getValue ,
  metaToMetaItem ,
  nextDiffusion ,
  audioVersions ,
  duration ,
  genre ,
  available ,
  allDiffusions ,
  makeMetas ,
  Presse ,
}
/* Zone_Type Not a pure module */
